function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Carousel from "segments/desktop/core-components/carousel/carousel";
import Title from "segments/desktop/core-components/title/title";
import HighlightCard from "./highlight-card/highlight-card-component";
import { StyledWhatsNewMobileSecondFoldComponent } from "./whats-new-mobile-second-fold-component.scss";
const WhatsNewMobileSecondFoldComponent = (props)=>{
    const { releaseHighlightsArray } = props;
    const slicedReleaseHighlightsArray = releaseHighlightsArray.slice(0, 6);
    const itemRenderer = (highlight)=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "highlight-card-wrapper",
            children: /*#__PURE__*/ _jsx(HighlightCard, {
                imageUrl: highlight.cloudinaryUrl,
                title: highlight.title,
                description: highlight.shortText,
                articleLink: highlight.articleLink
            })
        });
    };
    const carouselProps = {
        items: slicedReleaseHighlightsArray,
        itemRenderer,
        defaultIndex: 0,
        infinite: false,
        slidesToShow: 1,
        dots: true,
        centerPadding: "10%",
        focusAfterSwipe: true,
        disableSlideOnStartClick: true
    };
    return /*#__PURE__*/ _jsxs(StyledWhatsNewMobileSecondFoldComponent, {
        className: "whats-new-mobile-second-fold",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "title-wrapper",
                children: /*#__PURE__*/ _jsx(Title, {
                    title: "Release highlights"
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "carousel-wrapper",
                children: /*#__PURE__*/ _jsx(Carousel, _object_spread({}, carouselProps))
            })
        ]
    });
};
export default WhatsNewMobileSecondFoldComponent;
